export default __webpack_public_path__ + "static/media/Akhlak-Hossain-Jim-Projects-Mouse-tracing-960.f77c5456.webp";